import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import Stack from "@mui/system/Stack";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/GridLegacy";
import useWindowSize from "@components/_hooks/useWindowSize";
import Link from "next/link";
import { useRouter } from "next/router";
import { useCategoryContext } from "../Providers/CategoryContext";


const CategoryPagination = ({
    per_page,
    count,
    page,
    from,
    to,
    total,
    handlePaginationChange,
}) => {
    const { isMobile } = useWindowSize();
    const router = useRouter();
    // Keep any existing query params except "page"
    const { page: _page, ...restQuery } = router.query;

    const {
        loadMoreProducts,
    } = useCategoryContext();

    return (
        <Stack className="mb-4" spacing={2} direction="row">
            <Grid rowSpacing={{ xs: 2, md: 0 }} justifyContent="center" container>
                <Grid className="d-flex" item>
                    <Typography className="text-vertical" component="span">
                        Results {from} - {to} of {total}
                    </Typography>
                    &nbsp;&nbsp;&nbsp;
                    <Typography className="text-vertical" component="span">
                        Showing {per_page} per page
                    </Typography>
                </Grid>

                <Grid item>
                    <Pagination
                        page={page}
                        count={count}
                        siblingCount={isMobile ? 2 : 4}
                        color="primary"
                        variant="outlined"
                        shape="rounded"
                        onChange={handlePaginationChange}
                        renderItem={(item) => {

                            const href =
                                item.page === 1
                                    ? { query: restQuery }
                                    : {
                                        query: { ...restQuery, ...(item.page > 1 && { page: item.page }) },
                                    };

                            return (
                                <PaginationItem
                                    component={Link}
                                    href={href}
                                    {...item}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        loadMoreProducts(item.page)
                                    }}
                                />
                            );
                        }}
                    />
                </Grid>
            </Grid>
        </Stack>
    );
};

export default CategoryPagination;
